__turbopack_context__.v({
  "bannerContainer": "RingWithHome-module__29MYIG__bannerContainer",
  "bannerImageWrapper": "RingWithHome-module__29MYIG__bannerImageWrapper",
  "cardAsset": "RingWithHome-module__29MYIG__cardAsset",
  "cardImage": "RingWithHome-module__29MYIG__cardImage",
  "cardSubtitle": "RingWithHome-module__29MYIG__cardSubtitle",
  "cardText": "RingWithHome-module__29MYIG__cardText",
  "cardTitle": "RingWithHome-module__29MYIG__cardTitle",
  "darkCard": "RingWithHome-module__29MYIG__darkCard",
  "grid": "RingWithHome-module__29MYIG__grid",
  "section": "RingWithHome-module__29MYIG__section",
});
